// Display formats the projection-details surfaces render values with. Column
// copy itself lives on the per-strategy presentation objects; this module owns
// only value formatting.
export type GlossaryFormat =
  | 'currency'
  | 'integer'
  | 'percent'
  | 'days'
  | 'months'
  | 'years'
  | 'year'
  | 'boolean'
  | 'text';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const percentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 2,
});

export function formatValue(value: unknown, format: GlossaryFormat): string {
  if (value === null || value === undefined) return '—';

  switch (format) {
    case 'currency':
      return typeof value === 'number' ? currencyFormatter.format(value) : String(value);
    case 'percent':
      return typeof value === 'number' ? percentFormatter.format(value) : String(value);
    case 'integer':
      return typeof value === 'number' ? Math.round(value).toLocaleString() : String(value);
    case 'days':
      return typeof value === 'number' ? `${value.toFixed(value % 1 ? 1 : 0)}d` : String(value);
    case 'months':
      return typeof value === 'number' ? `${value} mo` : String(value);
    case 'years':
      return typeof value === 'number' ? `${value} yr` : String(value);
    case 'year':
      return typeof value === 'number' ? String(Math.round(value)) : String(value);
    case 'boolean':
      return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : String(value);
    case 'text':
    default:
      return String(value);
  }
}
